module.exports = __webpack_public_path__ + "static/media/elite-mobile-medium-blob.f46527c8.svg";